import React from 'react'
import ListCustomerTableHead from "./ListCustomerTableHead"
import ListCustomerTableBody from "./ListCustomerTableBody"
import {Spin} from "antd"

function ListCustomerTable(props) {
    const {loading, error, listContact, selectAll, onCheckALl, arrSelected, onSelected} = props

    return <div className="LeadTable">
        <Spin spinning={loading} tip="Đang lấy dữ liệu...">
            <table className="table">
                <ListCustomerTableHead selectAll={selectAll}
                                       onCheckALl={onCheckALl}
                                       arrSelected={arrSelected}/>
                <ListCustomerTableBody loading={loading} error={error} listContact={listContact}
                                       arrSelected={arrSelected}
                                       onSelected={onSelected}/>
            </table>
        </Spin>
    </div>
}

export default ListCustomerTable
